// components/CustomNodes/Address/checkForServiceNode.jsx
import React, { useState } from 'react';
import { PageContainer, Button } from '../../../components/common';
import { ELEMENT_IDS } from '../../../constants/ids';
import { COMPANY_CONFIG } from '../../../constants/companyConfig';
import './checkForServiceNode.css';

const AddressNode = () => {
  const [selectedType, setSelectedType] = useState('residential');

  // Safe access with fallbacks - no functionality changes
  const isDetailedForm = COMPANY_CONFIG?.ui?.addressForm?.type === 'detailed';
  const icons = COMPANY_CONFIG?.ui?.addressForm?.icons || {
    residential: '/images/icons/Residential.png',
    residentialActive: '/images/icons/Residential-active.png',
    business: '/images/icons/Business.png',
    businessActive: '/images/icons/Business-active.png',
  };

  const handleCardClick = (type) => {
    setSelectedType(type);
  };
  const activeBusinessImage = `card-icon-business-${COMPANY_CONFIG.domain}`;
  const activeResidenceImage = `card-icon-residence-${COMPANY_CONFIG.domain}`;
  return (
    <PageContainer className="checkForServiceNode-Container">
      <div className="checkForServiceNode-topSection">
        <h2 className="checkForServiceNode-heading">
          Check Service Availability
        </h2>
        <p className="checkForServiceNode-subHeading">
          {
            COMPANY_CONFIG.domain === "highline"
            ? "Check for available services":
              "Enter your address to see if service is available in your area."
          }
        </p>
      </div>

      <div className="checkForServiceNode-addressBox">
        <p className="card-text description">
          Please let us know your address if this is residential or business.
        </p>

        <div className="checkForServiceNode-cardContainer">
          {/* Residential Card */}
          <div
            className={`checkForServiceNode-card ${selectedType === 'residential' ? 'active' : ''}`}
            onClick={() => handleCardClick('residential')}
          >
            <img
              key={`residential-${selectedType}`}
              src={
                selectedType === 'residential'
                  ? icons.residentialActive
                  : icons.residential
              }
              alt="Residential"
              className={activeResidenceImage}
              onLoad={() =>
                console.log(
                  '✅ Residential loaded:',
                  selectedType === 'residential'
                    ? icons.residentialActive
                    : icons.residential
                )
              }
              onError={(e) =>
                console.error('❌ Residential failed:', e.target.src)
              }
            />
            <div className="card-text">
              <h4>Residential</h4>
            </div>
          </div>

          {/* Business Card */}
          <div
            className={`checkForServiceNode-card ${selectedType === 'business' ? 'active' : ''}`}
            onClick={() => handleCardClick('business')}
          >
            <img
              key={`business-${selectedType}`}
              src={
                selectedType === 'business'
                  ? icons.businessActive
                  : icons.business
              }
              alt="Business"
              className={activeBusinessImage}
              onLoad={() =>
                console.log(
                  '✅ Business loaded:',
                  selectedType === 'business'
                    ? icons.businessActive
                    : icons.business
                )
              }
              onError={(e) =>
                console.error('❌ Business failed:', e.target.src)
              }
            />
            <div className="card-text">
              <h4>Business</h4>
            </div>
          </div>
        </div>

        {/* Conditional Form - Archtop gets detailed form, PRTC gets simple */}
        {isDetailedForm ? (
          // ARCHTOP: Detailed multi-field form
          <div className="checkForServiceNode-formContainer">
            <div className="checkForServiceNode-formGroup checkForServiceNode-fullWidth">
              <label
                htmlFor={ELEMENT_IDS.ADDRESS_INPUT}
                className="checkForServiceNode-inputLabel"
              >
                Street Address
                <span className="checkForServiceNode-required">*</span>
              </label>
              <div className="checkForServiceNode-inputContainer" id='address-service'>
                <input
                  id={ELEMENT_IDS.ADDRESS_INPUT}
                  type="text"
                  className="checkForServiceNode-addressInput"
                  placeholder="Enter street address"
                />
                <div
                  id="address-loader1"
                  className="checkForServiceNode-addressLoader"
                  style={{ display: 'none' }}
                >
                  <div className="checkForServiceNode-spinner"></div>
                </div>
              </div>
            </div>

            <div className="checkForServiceNode-formRow">
              <div className="checkForServiceNode-formGroup checkForServiceNode-aptField">
                <label
                  htmlFor="apt-number"
                  className="checkForServiceNode-inputLabel"
                >
                  Apt #
                </label>
                <input
                  id="apt-number"
                  type="text"
                  className="checkForServiceNode-addressInput"
                  placeholder=""
                  disabled
                />
              </div>
              <div className="checkForServiceNode-formGroup checkForServiceNode-cityField">
                <label
                  htmlFor="city"
                  className="checkForServiceNode-inputLabel"
                >
                  City
                </label>
                <input
                  id="city"
                  type="text"
                  className="checkForServiceNode-addressInput"
                  placeholder="Enter city"
                  disabled
                />
              </div>
            </div>

            <div className="checkForServiceNode-formRow">
              <div className="checkForServiceNode-formGroup checkForServiceNode-stateField">
                <label
                  htmlFor="state"
                  className="checkForServiceNode-inputLabel"
                >
                  State<span className="checkForServiceNode-required">*</span>
                </label>
                <input
                  id="state"
                  type="text"
                  className="checkForServiceNode-addressInput"
                  placeholder="Enter state"
                  disabled
                />
              </div>
              <div className="checkForServiceNode-formGroup checkForServiceNode-zipField">
                <label
                  htmlFor="zip-code"
                  className="checkForServiceNode-inputLabel"
                >
                  Zip Code
                  <span className="checkForServiceNode-required">*</span>
                </label>
                <input
                  id="zip-code"
                  type="text"
                  className="checkForServiceNode-addressInput"
                  placeholder="Enter zip code"
                  disabled
                />
              </div>
            </div>
          </div>
        ) : (
          // PRTC: Simple single address field
          <div className="checkForServiceNode-formGroup" id='address-service'>
            <label
              htmlFor={ELEMENT_IDS.ADDRESS_INPUT}
              className="checkForServiceNode-inputLabel"
            >
              Enter your address
            </label>
            <input
              id={ELEMENT_IDS.ADDRESS_INPUT}
              type="text"
              className="checkForServiceNode-addressInput"
              placeholder="Enter your full address"
            />
          </div>
        )}
      </div>

      <div className="checkForServiceNode-bottomActions">
        <Button customId={ELEMENT_IDS.NEXT_STEP_BUTTON} label="Next" disabled />
      </div>
      <p className="checkForServiceNode-signInText">
        Already have an account? <a href="/login">Sign in</a>
      </p>
    </PageContainer>
  );
};

export default AddressNode;
